import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, unref as _unref, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { countries } from '@/models/country.model';
import { Address } from '@/models/info.model';
import { PropType, ref, watch } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AddressFields',
  props: {
  modelValue: {
    type: Object as PropType<Address>,
    required: true,
  },
  label: {
    type: String,
  },
  removable: {
    type: Boolean,
  },
  disabled: {
    type: Boolean,
  },
},
  emits: ['update:modelValue', 'change', 'remove'],
  setup(__props, { emit: __emit }) {

const props = __props;

const address = ref<Address>({ ...props.modelValue });

const emit = __emit;

function update() {
  emit('update:modelValue', address.value);
  emit('change', address.value);
}

function remove() {
  emit('remove');
}

watch(
  () => props.modelValue,
  () => {
    address.value = { ...props.modelValue };
  },
);

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_autocomplete = _resolveComponent("v-autocomplete")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.label)
      ? (_openBlock(), _createBlock(_component_v_row, {
          key: 0,
          dense: ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, null, {
              default: _withCtx(() => [
                _createElementVNode("h4", null, _toDisplayString(__props.label), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_v_row, { dense: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, {
          cols: __props.removable ? 3 : 4
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: address.value.name,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((address.value.name) = $event)),
              onChange: update,
              label: _ctx.$t('initiative.edit.name'),
              density: "compact",
              disabled: __props.disabled,
              "hide-details": true
            }, null, 8, ["modelValue", "label", "disabled"])
          ]),
          _: 1
        }, 8, ["cols"]),
        _createVNode(_component_v_col, { cols: "5" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: address.value.street,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((address.value.street) = $event)),
              onChange: update,
              label: _ctx.$t('initiative.edit.street'),
              density: "compact",
              disabled: __props.disabled,
              "hide-details": true
            }, null, 8, ["modelValue", "label", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: address.value.house_number,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((address.value.house_number) = $event)),
              onChange: update,
              label: _ctx.$t('initiative.edit.housenumber'),
              density: "compact",
              disabled: __props.disabled,
              "hide-details": true
            }, null, 8, ["modelValue", "label", "disabled"])
          ]),
          _: 1
        }),
        (__props.removable)
          ? (_openBlock(), _createBlock(_component_v_col, {
              key: 0,
              cols: "1"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  icon: "mdi-delete-outline",
                  class: "remove-button mt-2",
                  density: "compact",
                  onClick: _withModifiers(remove, ["prevent"])
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { dense: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "6" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: address.value.address_extra,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((address.value.address_extra) = $event)),
              onChange: update,
              label: _ctx.$t('initiative.edit.extra'),
              density: "compact",
              disabled: __props.disabled,
              "hide-details": true
            }, null, 8, ["modelValue", "label", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "6" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: address.value.neighbourhood,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((address.value.neighbourhood) = $event)),
              onChange: update,
              density: "compact",
              label: _ctx.$t('initiative.edit.neighbourhood'),
              disabled: __props.disabled,
              "hide-details": true
            }, null, 8, ["modelValue", "label", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { dense: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "4" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: address.value.postal_code,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((address.value.postal_code) = $event)),
              onChange: update,
              label: _ctx.$t('initiative.edit.postalcode'),
              density: "compact",
              disabled: __props.disabled,
              "hide-details": true
            }, null, 8, ["modelValue", "label", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "8" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_text_field, {
              modelValue: address.value.city,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((address.value.city) = $event)),
              onChange: update,
              label: _ctx.$t('initiative.edit.city'),
              density: "compact",
              disabled: __props.disabled,
              "hide-details": true
            }, null, 8, ["modelValue", "label", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, { dense: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "6" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_autocomplete, {
              modelValue: address.value.country,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((address.value.country) = $event)),
              onChange: update,
              items: _unref(countries),
              density: "compact",
              label: _ctx.$t('initiative.edit.country'),
              "item-title": "text",
              "item-value": "value",
              disabled: __props.disabled,
              "hide-details": true
            }, null, 8, ["modelValue", "items", "label", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_checkbox, {
              label: _ctx.$t('initiative.edit.exact'),
              density: "compact",
              modelValue: address.value.isSpecific,
              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((address.value.isSpecific) = $event)),
              disabled: __props.disabled,
              onChange: update
            }, null, 8, ["label", "modelValue", "disabled"])
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, { cols: "3" }, {
          default: _withCtx(() => [
            (!address.value.isSpecific)
              ? (_openBlock(), _createBlock(_component_v_text_field, {
                  key: 0,
                  label: _ctx.$t('initiative.edit.radius'),
                  density: "compact",
                  hint: "In kilometres",
                  suffix: "km",
                  onChange: update,
                  modelValue: address.value.radius,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((address.value.radius) = $event)),
                  modelModifiers: { number: true },
                  disabled: __props.disabled
                }, null, 8, ["label", "modelValue", "disabled"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}
}

})